import styled from "styled-components";

const OrderlistWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  line-height: initial;
  overflow-x: auto;
  overflow-y: hidden;
  min-width: 0;
  // width: 100%;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  .providerContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 10px;
    flex-shrink: 0; // Prevent containers from shrinking

    .providerTitle {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    h4 {
      padding-top: 10px;
    }

    .ant-checkbox + span {
      font-size: 18px;
    }
  }
`;

export default OrderlistWrapper;
